// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { localStore } from '@/utils/storage';

const AppVersion = '1.1.0';

/** 获取短信 POST /api/Sms/PhoneSend */
export async function getSMScaptcha(data: any, options?: { [key: string]: any }) {
    const token: string = localStore.get('shop_token') || ''; //避免全局获取token失效

    return request<any>('/api/Sms/PhoneSend', {
        method: 'POST',
        headers: {
            'server': 1,
			'ba-user-token': token,
			'app-version': AppVersion,
        },
        data,
        ...(options || {}),
    });
}

/** 上传图片 */
export async function uploadSetImg(data: any, options?: { [key: string]: any }) {
    return request('/api/common.Common/setImg', {
		method: 'POST',
		data,
        ...(options || {}),
	});
}

/** 上传图片 */
export async function uploadFlie(data: any, options?: { [key: string]: any }) {
    return request('/api/common.Common/upload', {
		method: 'POST',
		data,
        ...(options || {}),
	});
}

/** 上传图片 */
export async function uploadAuthentication(data: any, options?: { [key: string]: any }) {
    return request('/api/common.Common/upload2', {
		method: 'POST',
		data,
        ...(options || {}),
	});
}

/** 删除图片 */
export async function delImage(params: any) {
    return request('/api/shopkeeper.Order/SetOrderTicketImg', {
		method: 'GET',
		params,
	});
}
